// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__XNONV","imageContainer":"style_imageContainer__sE2l1","image":"style_image__rdbz5","hotArea":"style_hotArea__23T5h"};